import {
  Clock,
  Coins,
  Eye,
  Sparkles,
  Tag,
  TrendingUp,
} from "lucide-react";

export const ADMIN_P2P_SORT_ICONS = {
  newest: Sparkles,
  oldest: Clock,
  pool: TrendingUp,
  stake: Coins,
};

export const ADMIN_PREDICTION_SORT_ICONS = {
  newest: Sparkles,
  oldest: Clock,
  views: Eye,
  price: Tag,
};
